var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ExpandableContactFormComponent } from './expandable-contact-form.component';
var ExpandableContactFormMobileComponent = /** @class */ (function (_super) {
    __extends(ExpandableContactFormMobileComponent, _super);
    function ExpandableContactFormMobileComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ExpandableContactFormMobileComponent;
}(ExpandableContactFormComponent));
export { ExpandableContactFormMobileComponent };



// WEBPACK FOOTER //
// ./src/app/shared/expandable-contact-form/expandable-contact-form-mobile.component.ts.pre-build-optimizer.js